<template>
  <div>
    <div style="margin-bottom:1em;height: 4.25em;text-align: right;">
      <label style="margin-bottom: 0.5em !important;">Date</label>
      <datepicker v-model="date" style="padding-top:0.75em;" class="datepicker_input"></datepicker>
    </div>
    <div>
      <label style="display:block;margin-bottom:0.5em;text-align: right;">Time</label>
      <vue-timepicker v-model="time" @change="onChangeTime" format="HH:mm:ss" style="float:right;"></vue-timepicker>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'

export default {
  name: 'DateTimePicker',
  components: {
    Datepicker,
    VueTimepicker
  },
  props: ['defaultValue'],
  methods: {
    update(){
      if(!this.date) return;

      let date = moment(this.date).format('YYYY-MM-DD');
      let { HH, mm, ss } = this.time;
      let time = `${HH}:${mm}:${ss}`;

      this.$emit('input', `${date}T${time}`);
    },
    onChangeTime(newVal){
      let { HH, mm, ss } = newVal.data;
      if(!HH) HH = "00";
      if(!mm) mm = "00";
      if(!ss) ss = "00";

      let value = `${HH}:${mm}:${ss}`;
      this.time = { HH, mm, ss }
      this.update();
    }
  },
  computed: {
    
  },
  data(){
    let date = null;
    let time = {};
    let s = null;
    
    try {
      s = this.defaultValue.split('T');
    } catch(e){}

    try {
      date = s[0];
    } catch(e){}

    try {
      let s_ = s[1].split(':');
      time = {HH: s_[0], mm: s_[1], ss: s_[2]};
    } catch(e){}

    return {
      date,
      time
    }
  },
  watch: {
    date(newVal){
      this.update();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/DateTimePicker.vue